<template>
  <div class="tab_box">
    <!-- 操作按钮 -->
    <list-btn
      :uploadUrl="uploadUrl"
      :downloadUrl="downloadUrl"
      :postExcelData="postExcelData"
      @uploadExcel="uploadExcel"
      @uploadBtn="uploadBtn"
      @add="add"
      @del="del"
      @alter="edit"
      isAdd
      isDel
      isExcel
      :isAlter="isEdit"
      ref="actionbtn"
    ></list-btn>

    <!-- 新增弹窗 -->
    <el-dialog
      width="900px"
      customClass="dialog_detail_style"
      title="选择物料"
      :visible.sync="dialogSelectMatters"
      @close="cancelSelect"
      v-dialogDrag
    >
      <matter-stock-list
        class="contnet_box"
        ref="selectMatter"
        :selectedList="selectedMatterSale"
        @getSelect="getSelect"
        :fromData="fromData"
      ></matter-stock-list>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelSelect">取 消</el-button>
        <el-button type="primary" @click="selectMattersOk">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 错误的表格-->
    <!-- <el-button type="text" @click="dialogTableVisible = true">打开嵌套表格的 Dialog</el-button> -->
    <!-- <el-dialog title="错误的上传数据" :visible.sync="isExcelError" width="900px">
      <tab-list :tabList="excelErrorList" :columns="excelErrorTabColumns" isno nheight="400">
      </tab-list>
    </el-dialog>-->

    <!-- 可编辑的表格 -->
    <!-- <edit-tab-list ref="editTabList" :columns="tabColums" :listArr="selectedMatterSale" style="width:100%;"></edit-tab-list> -->
    <vxe-table
      border
      resizable
      ref="editTabLists"
      :data="selectedMatterSale"
      :edit-config="{trigger: 'click', mode: 'cell'}"
      @edit-actived="editActivedEvent"
      @cell-click="loadInventoryEvent"
      @cell-dblclick="editActivedEvent"
      @edit-closed="editClosedEvent"
    >
      <vxe-table-column type="checkbox" width="40"></vxe-table-column>
      <vxe-table-column field="materialCode" title="物料编码"></vxe-table-column>
      <vxe-table-column field="materialDesc" title="物料描述"></vxe-table-column>
      <vxe-table-column
        field="basicUnitDesc"
        title="计量单位"
        :edit-render="{name: 'select', options: targetUnitList,events:{change:changEvent}}"
      ></vxe-table-column>

      <vxe-table-column
        field="factoryDesc"
        title="工厂"
        :edit-render="{name: 'select', options: factoryLists}"
      ></vxe-table-column>
      <vxe-table-column
        field="inventoryDesc"
        title="库存地"
        :edit-render="{name: 'select', options: inventoryList}"
      ></vxe-table-column>
      <vxe-table-column
        field="targetNum"
        title="数量"
        :edit-render="{name: 'input', attrs: {type: 'number',disabled: false}}"
      ></vxe-table-column>
      <vxe-table-column
        field="deliveryDate"
        width="155"
        title="交货日期"
        :edit-render="{type: 'default'}"
      >
        <template v-slot:edit="{ row }">
          <el-date-picker
            v-model="row.deliveryDate"
            type="date"
            :picker-options="pickerOptions0"
          >{{row.deliveryDate}}</el-date-picker>
        </template>
        <template v-slot="{ row }">{{ formatDate(row.deliveryDate, 'yyyy-MM-dd') }}</template>
      </vxe-table-column>
      <vxe-table-column
        field="netPrice"
        title="销售价格"
        :edit-render="{name: 'input', attrs: {type: 'number',disabled: false}}"
      ></vxe-table-column>
      <vxe-table-column field="taxm1" title="销项税(%)" :edit-render="{name: 'input'}"></vxe-table-column>
      <vxe-table-column field="materialGroup" title="物料组"></vxe-table-column>
      <vxe-table-column field="origin" title="物料来源"></vxe-table-column>
    </vxe-table>

    <MaterialQueryWindow
      :show="showMtrlWindow"
      @onConfirmSelected="onCreateMtrl2GoodsRelate"
      @onCloseWindow="onCloseMtrlWindow"
    ></MaterialQueryWindow>
  </div>
</template>
<script>
import { excelUpload, excelDownload } from "api/excel.js";
import { targetUnit } from "api/business.js";
import { fstockApi } from "api/base.js";
import listBtn from "components/btn/listBtn.vue";
import matterStockList from "components/matters/orderNew.vue";
import tabList from "components/table/list.vue";
import editTabList from "components/table/vxeTab.vue";
import XEUtils from "xe-utils";
import { mapState, mapActions } from "vuex";
import MaterialQueryWindow from "busicomponent/window/MaterialQueryWindow.vue";
export default {
  components: {
    listBtn,
    matterStockList,
    tabList,
    editTabList,
    MaterialQueryWindow
  },
  props: {
    fromData: Object,
    noFromData: Object,
    factoryList: Array
  },
  watch: {
    factoryList(val) {
      console.log(val, "==11==");
      this.inventoryList = [];
      this.factoryLists = val;
      console.log(this.factoryLists, "==333=");
      this.factoryLists.forEach(item_s => {
        item_s.label = item_s.factoryDisplay;
        item_s.value = item_s.factoryDisplay;
      });
    },
    "fromData.origin": function(val, old) {
      console.log(val);
      if (val == "线上") {
        this.isEdit = true;
      } else {
        this.isEdit = false;
      }
    }
  },
  computed: {
    ...mapState("cache", ["selectedMatterSale"]),
    selectedMatterSaleList() {
      this.selectedMatterSale.forEach((item, index) => {
        if (!item.targetUnitId) {
          item.targetUnitId = item.basicUnitId;
          item.targetUnit = item.basicUnitCode;
          item.targetUnitDesc = item.basicUnitDesc;
        }
      });
      return this.selectedMatterSale;
    }
  },
  data() {
    return {
      showMtrlWindow: false,
      isEdit: false,
      pickerOptions0: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        }
      },
      inventoryList: [], //库存地
      inventoryQueryWhere: {
        page: 1,
        pageSize: 10000,
        searchCriteria: {
          factoryCode: 0
        }
      },
      factoryLists: [],
      tableData: [],
      sexList: [],
      targetUnitList: [],
      dialogSelectMatters: false,
      selectList: [], //所选数据
      selectedList: [], //已选数据
      sdata: {}, //已选中的
      postExcelData: {}, //EXCEL上传时所需传递的参数
      downloadUrl: excelDownload.saleOutStock,
      uploadUrl: excelUpload.saleOutStock
    };
  },
  created() {
    //交货日期默认今天
    let nowData = new Date();
    this.$set(this.fromData, "startDate", nowData);
    // this.tableData = window.MOCK_DATA_LIST.slice(0, 6)
    this.findSexList();

    // let targetUnitList = await this.$post(targetUnit.list,this.$store.state.getAllPage);
    // console.log(targetUnitList,'8888888888');
    // if(targetUnitList.status){
    //   this.targetUnitList = targetUnitList.data.list;
    //   this.targetUnitList.forEach((item)=>{
    //     item.label = item.unitDesc;
    //     item.value = item.unitDesc;
    //   });
    // }
  },
  mounted: function() {
    this.$nextTick(function() {});
  },
  updated: function() {},
  methods: {
    factoryChange({ row }, event) {
      console.log(event.target.value, "=333===");
      let obj = this.factoryLists.find(
        v => v.factoryDisplay === event.target.value
      );
      if (obj) {
        row.factoryId = obj.factoryId;
        row.factoryCode = obj.factoryCode;
        row.factoryDesc = obj.factoryDesc;
        row.factoryDisplay = obj.factoryCode + "-" + obj.factoryDesc;
      }
      console.log(row.factoryId);
      if (row.factoryId) {
        this.loadInventory(row);
      }
    },
    getSelectLabel(row) {
      row.inventoryCode = "";
      row.inventoryDesc = "";
      let record = this.inventoryList.find(
        item => item.inventoryId == row.inventoryId
      );
      if (record) {
        row.inventoryCode = record.inventoryCode;
        row.inventoryDesc = record.inventoryDesc;
      }
      return record ? record.inventoryDesc : null;
    },

    cellMouseleaveEvent({ row, rowIndex, column, columnIndex }, event) {},
    /**
     * 加载库存地点
     */
    async loadInventory(row) {
      let objSelect = {};
      objSelect.key = -1;
      objSelect.value = "";
      objSelect.label = "请选择";

      this.inventoryQueryWhere.searchCriteria.factoryId = row.factoryId;
      let inventoryResults = await this.$post(
        fstockApi.list,
        this.inventoryQueryWhere
      );
      if (inventoryResults.status) {
        this.inventoryList = inventoryResults.data.list;
        this.inventoryList.forEach(item => {
          item.value = item.inventoryDesc;
          item.label = item.inventoryDesc;
          item.key = item.inventoryId;
        });
        //row.iteminventoryList=this.inventoryList;
        this.inventoryList.push(objSelect);
        this.inventoryList = this.inventoryList.sort(v => v.key);
      } else {
        this.inventoryList = [];
      }
    },
    /**
     * 工厂更改
     */
    onChangeFactory({ row }, evnt) {
      this.loadInventory(row);
    },
    onCancelSelect() {
      this.isShowMaterialDialog = false;
      this.$refs.selectMatter.cancelSelect();
    },
    onGetSelect(materialData) {
      this.selectedList = materialData;
    },
    formatDate(value, format) {
      if (!value) {
        return "";
      }
      return XEUtils.toDateString(value, format);
    },
    findSexList() {},
    //判断每一条数据的来源是否为线上，如果为线上，则不允许更改数量和价格
    editActivedEvent({ row, column }) {
      let xTable = this.$refs.editTabLists;
      let targetNum = xTable.getColumnByField("targetNum");
      let netPrice = xTable.getColumnByField("netPrice");
      // origin 值为 线上 的列禁止编辑
      let isOriginDisabled = row.origin == "线上";
      // console.log(isOriginDisabled)
      targetNum.editRender.attrs.disabled = isOriginDisabled;
      netPrice.editRender.attrs.disabled = isOriginDisabled;
      // console.log(targetNum.editRender.attrs.disabled)
      // console.log(netPrice.editRender.attrs.disabled)
    },
    loadInventoryEvent({ row, column }) {
      console.log(row, column);
      if (column.title == "库存地") {
        this.loadInventory(row);
      }
      this.updateTargetUnitList(row);
    },
    editClosedEvent({ row, column }, event) {
      console.log(`关闭 ${column.title} 列编辑`);
    },

    ...mapActions("cache", ["setSelectedSaleOrderMaterial"]),
    //选中数据
    selectSdata(data) {
      this.sdata = data;
    },
    //获取所选
    getSelect(res) {
      console.log(res);
      this.selectList = res;
      //  this.sexList=res;
    },
    //确定所选
    selectMattersOk() {
      //console.log(this.selectList);
      //如果销售价格维护过，就默认取这个价格

      this.selectList.forEach(item => {
        // this.targetUnitList = item.multiUnit
        // this.targetUnitList.forEach((item_s)=>{
        //   item_s.label = item_s.denominatorUnitDesc;
        //   item_s.value = item_s.denominatorUnitDesc;
        // });
        //inventoryId inventoryDesc inventoryCode

        //工厂信息
        let nameText = item.factoryCode + "-" + item.factoryDesc;
        let nameTexts = item.factoryDesc.split("-");
        if (nameTexts.length < 2) {
          item.factoryDesc = nameText;
        }
        let factoryData = {
          factoryId: item.factoryId,
          factoryCode: item.factoryCode,
          factoryDisplay: nameText,
          factoryDesc: item.factoryDesc,
          label: nameText,
          value: nameText
        };
        let exist = this.factoryLists.find(
          v => v.factoryCode === item.factoryCode
        );
        if (exist == null || exist == "undefined") {
          this.factoryLists.push(factoryData);
        }
        //inventoryList
        //库存地点
        if (item.salePrice != null) {
          item.netPrice = item.salePrice;
        }
        let kcText = item.inventoryCode + "-" + item.inventoryDesc;
        let kcTexts = item.inventoryDesc.split("-");
        if (kcTexts.length < 2) {
          item.inventoryDesc = kcText;
        }

        let inventoryData = {
          inventoryId: item.inventoryId,
          inventoryCode: item.inventoryCode,
          inventoryDesc: kcText,
          key: item.inventoryId,
          label: kcText,
          value: kcText
        };
        let exist_Inventory = this.inventoryList.find(
          v => v.inventoryId === item.inventoryId
        );
        if (exist_Inventory == null || exist_Inventory == "undefined") {
          this.inventoryList.push(inventoryData);
        }
      });
      console.log(this.factoryLists, "工厂信息...aaaaa");
      this.setSelectedSaleOrderMaterial({
        arr: this.selectList,
        other: {
          targetUnitDesc: this.fromData.targetUnitDesc, //基本计量单位
          targetUnitCode: this.fromData.targetUnitCode,
          targetUnitId: this.fromData.targetUnitId
        }
      });
      this.dialogSelectMatters = false;
    },
    //点击每一行的计量单位时，获取每一行的计量单位下拉列表
    updateTargetUnitList(row) {
      // console.log(row.materialCode)
      let ptype = row.materialCode;
      let pList = [];
      if (ptype) {
        let item = this.selectList.find(item => item.materialCode === ptype);
        if (item) {
          pList = item.multiUnit;
          console.log(pList);
        }
      }
      this.targetUnitList = pList;
      this.targetUnitList.forEach(item_s => {
        item_s.label = item_s.denominatorUnitDesc;
        item_s.value = item_s.denominatorUnitDesc;
      });
    },
    //取消所选
    cancelSelect() {
      this.$refs.selectMatter.cancelSelect();
      this.dialogSelectMatters = false;
    },
    //新增按钮
    add() {
      if (!this.fromData.companyId) {
        this.$message.error("请选择公司");
        return false;
      }
      if (!this.fromData.saleVoucherTypeDesc) {
        this.$message.error("请选择订单类型");
        return false;
      }
      if (!this.fromData.distriChannelDesc) {
        this.$message.error("请选择分销渠道");
        return false;
      }
      if (!this.fromData.customerId) {
        this.$message.error("请选择客户");
        return false;
      }
      if (!this.fromData.postingDate) {
        this.$message.error("请选择单据日期");
        return false;
      }
      if (!this.fromData.orderer) {
        this.$message.error("请选择联系人");
        return false;
      }
      if (!this.fromData.telephone) {
        this.$message.error("请选择联系电话");
        return false;
      }
      if (!this.fromData.address) {
        this.$message.error("请选择送货地址");
        return false;
      }
      this.dialogSelectMatters = true;
    },
    uploadBtn() {
      if (!this.fromData.companyId) {
        this.$message.error("请选择公司");
        return false;
      }
      if (!this.fromData.customerId) {
        this.$message.error("请选择客户");
        return false;
      }

      this.postExcelData = {
        factoryId: this.fromData.factoryId,
        factoryCode: this.fromData.factoryCode,
        factoryDesc: this.fromData.factoryDesc,
        inventoryId: this.fromData.inventoryId,
        inventoryCode: this.fromData.inventoryCode,
        inventoryDesc: this.fromData.inventoryDesc
      };
      this.$refs.actionbtn.uploadDialog = true;
    },
    //删除
    del() {
      let vm = this;
      console.log(this.selectedMatterSale, "==333==");
      let delList = this.$refs.editTabLists.getCheckboxRecords();
      console.log(delList, "== 444 ==");
      //this.getSelectEvent();
      // let delList = this.$refs.editTabList.checkedList;
      if (delList.length < 1) {
        this.$message.error("请选择需要删除的记录");
      } else if (delList[0].origin == "线上") {
        this.$message.error("该销售订单来自于线上，不允许删除！");
        return;
      } else {
        this.$confirm("确认删除已选数据, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            delList.forEach(item => {
              let nowIndex = this.selectedMatterSale.findIndex(
                v => v.materialId === item.materialId
              );
              if (nowIndex != -1) {
                this.$store.state.cache.selectedMatterSale.splice(nowIndex, 1);
              }
            });
          })
          .catch(() => {});
      }
    },
    //编辑按钮
    edit() {
      // this.dialogSelectMatters = true;
      let delList = this.$refs.editTabLists.getCheckboxRecords();
      console.log(delList, "== 444 ==");
      if (delList.length < 1) {
        this.$message.error("请选择需要编辑的记录");
        return;
      }
      if (delList[0].origin == "线上") {
        this.$message.error("该销售订单来自于线上，不允许更改物料信息！");
        return;
      }
      this.showMtrlWindow = true;
    },
    //上传excel
    uploadExcel(res) {
      console.log(res, 6666);
      if (!res.data) return;
      let list = res.data.rightData;
      list.forEach(item => {
        let resIndex = this.selectedList.findIndex(
          v => v.materialCode === item.materialCode
        );
        if (resIndex != -1) {
          //存在相加
          let quantity = item.quantity + this.selectedList[resIndex].quantity;
          this.$set(this.selectedList[resIndex], "quantity", quantity);
        } else {
          let objData = {
            basicUnitCode: item.basicUnitCode,
            basicUnitDesc: item.basicUnitDesc,
            basicUnitId: item.basicUnitId,
            materialCode: item.materialCode,
            materialDesc: item.materialDesc,
            materialId: item.materialId,
            standardCurrAmount: item.purchasePrice, //价格
            quantity: item.quantity, //数量
            materialGroupDesc: item.materialGroupDesc, //物料组描述
            materialGroupId: item.materialGroupId, //物料组IE
            materialTypeId: item.materialTypeId, //物料类型
            materialTypeName: item.materialTypeName,
            // factoryCode: item.factoryCode,
            // factoryDesc: item.factoryDesc,
            // factoryId: item.factoryId,
            factoryCode: this.fromData.factoryCode, //工厂
            factoryDesc: this.fromData.factoryDesc,
            factoryId: this.fromData.factoryId,
            inventoryCode: this.fromData.inventoryCode, //库存地
            inventoryDesc: this.fromData.inventoryDes,
            inventoryId: this.fromData.inventoryId,
            customerCode: this.noFromData.customerCode, //客户
            customerDesc: this.noFromData.customerDesc,
            customerId: this.noFromData.customerId
          };
          this.selectedList.push(objData);
        }
      });

      //错误的
      let failData = res.data.failData;
      if (failData.length) {
        this.isExcelError = true;
        this.excelErrorList = failData;
      }
    },
    //判断当前输入数量是否大于库存数量
    isMaxNum(item, maxNum, index) {
      if (item) {
        item = item + "";
        item = item.replace(/[^\d]/g, "");
        if (item > maxNum) item = maxNum;
        this.$set(this.selectMatterList[index], "quantity", item);
      }
    },
    //计量单位改变
    changEvent({ row }, event) {
      console.log(event.target.value, "===13123231===", this.targetUnitList);
      let obj = this.targetUnitList.find(
        v => v.denominatorUnitDesc == event.target.value
      );
      console.log(obj);
      row.targetUnitId = obj.denominatorUnitId;
      row.targetUnit = obj.denominatorUnit;
      row.targetUnitDesc = obj.denominatorUnitDesc;
      console.log(row, "===  666666666 ==", event);
    },
    /**
     * 选中的物料
     */
    onCreateMtrl2GoodsRelate(rows) {
      let vm = this;
      if (rows) {
        //  console.log(rows)
        let EditList = this.$refs.editTabLists.getCheckboxRecords();
        EditList.forEach(item => {
          let nowIndex = this.selectedMatterSale.findIndex(
            v => v.materialId === item.materialId
          );
          if (nowIndex != -1) {
            // console.log(this.$store.state.cache.selectedMatterSale[nowIndex])
            this.$store.state.cache.selectedMatterSale[nowIndex].materialId =
              rows.materialId;
            this.$store.state.cache.selectedMatterSale[nowIndex].materialCode =
              rows.materialCode;
            this.$store.state.cache.selectedMatterSale[nowIndex].materialDesc =
              rows.materialDesc;
            this.$store.state.cache.selectedMatterSale[nowIndex].basicUnitId =
              rows.basicUnitId;
            this.$store.state.cache.selectedMatterSale[nowIndex].basicUnitCode =
              rows.basicUnitCode;
            this.$store.state.cache.selectedMatterSale[nowIndex].basicUnitDesc =
              rows.basicUnitDesc;
            this.$store.state.cache.selectedMatterSale[
              nowIndex
            ].materialGroupId = rows.materialGroupId;
            this.$store.state.cache.selectedMatterSale[nowIndex].materialGroup =
              rows.materialGroup;
            this.$store.state.cache.selectedMatterSale[
              nowIndex
            ].materialGroupDesc = rows.materialGroupDesc;
          }
        });
      }
    },
    /**
     * 触发物料查询窗口关闭
     */
    onCloseMtrlWindow() {
      this.showMtrlWindow = false;
    }
  }
};
</script>

<style>
</style>
